// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { createPortal } from 'react-dom'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import { LoadingIcon } from 'components'

const loaderWrapper = document.getElementById('connected-loader')

const ConnectedLoader = ({ loading }) => (
  createPortal(
    <LoadingIcon loading={loading} />,
    loaderWrapper,
  )
)

ConnectedLoader.propTypes = {
  loading: bool.isRequired,
}

// loading will be an int which represents the number of active
// async functions which should display the loading icon
const mapStateToProps = ({ loading }) => ({
  loading: !!loading,
})

export default connect(
  mapStateToProps,
)(ConnectedLoader)
